import { Directive, EventEmitter, Output, AfterViewInit, ElementRef, NgZone, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';

@Directive({
  selector: '[finAfterViewInit]',
  standalone: false,
})
export class AfterViewInitDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);
  private ngZone = inject(NgZone);
  private platform = inject(PLATFORM_ID);

  @Output() finAfterViewInit: EventEmitter<ElementRef> = new EventEmitter<ElementRef>();

  ngAfterViewInit(): void {
    if (isPlatformServer(this.platform)) {
      return;
    }

    setTimeout(() => {
      this.ngZone.run(() => {
        this.finAfterViewInit.emit(this.elementRef);
      });
    }, 0);
  }
}
